export function loadOrderTrack(orderId) {
  return {
    type: 'LOAD_ORDER_TRACK',
    orderId,
  };
}

export function loadOrderTrackCompletion(orderId, error, data) {
  return {
    type: 'LOAD_ORDER_TRACK_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function loadOrder(orderId) {
  return {
    type: 'LOAD_ORDER',
    orderId,
  };
}

export function loadOrderCompletion(orderId, data, error) {
  return {
    type: 'LOAD_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function loadStoreOrder(billNo) {
  return {
    type: 'LOAD_STORE_ORDER',
    billNo,
  };
}

export function loadStoreOrderCompletion(billNo, data, error) {
  return {
    type: 'LOAD_STORE_ORDER_COMPLETION',
    billNo,
    data,
    error,
  };
}

export function loadOrderList(query) {
  return {
    type: 'LOAD_ORDER_LIST',
    query,
    willReload: !!query,
  };
}

export function loadOrderListCompletion(error, list) {
  return {
    type: 'LOAD_ORDER_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadStoreOrderList(query) {
  return {
    type: 'LOAD_STORE_ORDER_LIST',
    query,
    willReload: !!query,
  };
}

export function loadStoreOrderListCompletion(error, list) {
  return {
    type: 'LOAD_STORE_ORDER_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadWeappOrderList(query) {
  return {
    type: 'LOAD_WEAPP_ORDER_LIST',
    query,
    willReload: !!query,
  };
}

export function loadWeappOrderListCompletion(error, list) {
  return {
    type: 'LOAD_WEAPP_ORDER_LIST_COMPLETION',
    error,
    list,
  };
}

export function cancelOrder(orderId) {
  return {
    type: 'CANCEL_ORDER',
    orderId,
  };
}

export function cancelOrderCompletion(orderId, data, error) {
  return {
    type: 'CANCEL_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function removeOrder(orderId) {
  return {
    type: 'REMOVE_ORDER',
    orderId,
  };
}

export function removeOrderCompletion(orderId, data, error) {
  return {
    type: 'REMOVE_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function refundOrder(orderId) {
  return {
    type: 'REFUND_ORDER',
    orderId,
  };
}

export function refundOrderCompletion(orderId, data, error) {
  return {
    type: 'REFUND_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function refundCouponOrder(orderId) {
  return {
    type: 'REFUND_COUPON_ORDER',
    orderId,
  };
}

export function refundCouponOrderCompletion(orderId, data, error) {
  return {
    type: 'REFUND_COUPON_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function receiptOrder(orderId) {
  return {
    type: 'RECEIPT_ORDER',
    orderId,
  };
}

export function receiptOrderCompletion(orderId, data, error) {
  return {
    type: 'RECEIPT_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function preCreateOrder(
  { selectedList = [], giftList = [], groupId = null },
  isOverseaOrder = 0,
  recoverData = {},
  needsDeleteFromCart = false
) {
  return {
    type: 'PRE_CREATE_ORDER',
    selectedList,
    giftList,
    groupId,
    isOverseaOrder,
    recoverData,
    needsDeleteFromCart,
  };
}

export function preCreateOrderCompletion(
  orderType,
  error,
  data,
  selectedList,
  giftList,
  groupId,
  recoverData
) {
  return {
    type: 'PRE_CREATE_ORDER_COMPLETION',
    error,
    data,
    orderType,
    selectedList,
    giftList,
    groupId,
    recoverData,
  };
}

export function createOrder(isOverseaOrder = 0) {
  return {
    type: 'CREATE_ORDER',
    isOverseaOrder,
  };
}

export function createOrderCompletion(
  isOverseaOrder = 0,
  error,
  data,
  payType
) {
  return {
    type: 'CREATE_ORDER_COMPLETION',
    isOverseaOrder,
    error,
    data,
    payType,
  };
}

export function resetOrderInfo(isOverseaOrder = 0) {
  return {
    type: 'RESET_ORDER_INFO',
    isOverseaOrder,
  };
}

export function pickOrderAddress(address, isOverseaOrder = 0) {
  return {
    type: 'PICK_ORDER_ADDRESS',
    address,
    isOverseaOrder,
  };
}

export function pickOrderCash(cashId, isOverseaOrder = 0) {
  return {
    type: 'PICK_ORDER_CASH',
    cashId,
    isOverseaOrder,
  };
}

export function pickOrderPostage(postageId, isOverseaOrder = 0) {
  return {
    type: 'PICK_ORDER_POSTAGE',
    postageId,
    isOverseaOrder,
  };
}

export function selectOrderPayType(orderId, payType, isOverseaOrder = 0) {
  return {
    type: 'SELECT_ORDER_PAY_TYPE',
    orderId,
    payType,
    isOverseaOrder,
  };
}

export function updateOverseaOrderAgreement() {
  return {
    type: 'UPDATE_OVERSEA_ORDER_AGREEMENT',
  };
}

export function updateOverseaOrderIdCard(idCardNo, idCardName) {
  return {
    type: 'UPDATE_OVERSEA_ORDER_IDCARD',
    idCardNo,
    idCardName,
  };
}

export function loadOrderSku(orderSkuId) {
  return {
    type: 'LOAD_ORDER_SKU',
    orderSkuId,
  };
}

export function loadOrderSkuCompletion(orderSkuId, error, data) {
  return {
    type: 'LOAD_ORDER_SKU_COMPLETION',
    orderSkuId,
    error,
    data,
  };
}

export function syncOrderSkuCommentEditInput(input, reset) {
  return {
    type: 'SYNC_ORDER_SKU_COMMENT_EDIT_INPUT',
    input,
    reset,
  };
}

export function editOrderSkuComment(orderSkuId) {
  return {
    type: 'EDIT_ORDER_SKU_COMMENT',
    orderSkuId,
  };
}

export function editOrderSkuCommentCompletion(orderSkuId, error, data) {
  return {
    type: 'EDIT_ORDER_SKU_COMMENT_COMPLETION',
    orderSkuId,
    error,
    data,
  };
}

export function loadAgentProductOrderDetail() {
  return {
    type: 'LOAD_AGENT_PRODUCT_ORDER_DETAIL',
  };
}

export function loadAgentProductOrderDetailCompletion(error, data) {
  return {
    type: 'LOAD_AGENT_PRODUCT_ORDER_DETAIL_COMPLETION',
    error,
    data,
  };
}
